import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {
  _screenX,
  _screenY,
  CanvasService,
} from '../../services/canvas/canvas.service';
import { IRIToId } from '../../util/iri';
import { Subscription } from 'rxjs';
import { setOverlay } from '../store/editor.actions';
import { selectOverlay } from '../store/selector/editor.selector';
import { map } from 'rxjs/operators';

@Component({
  selector: 'nw-new-element',
  templateUrl: './new-element.component.html',
  styleUrls: ['./new-element.component.scss'],
})
export class NewElementComponent implements OnInit, OnDestroy {
  // Add your component logic here
  overlay$ = this.cs.store.select(selectOverlay);

  isAiActive$ = this.overlay$.pipe(map(overlay => overlay === 'image-prompt'));
  hovered: typeof this.cs.shapeAddMode;
  constructor(
    private cs: CanvasService,
    private readonly cdr: ChangeDetectorRef,
  ) {}
  sub: Subscription;

  ngOnInit() {
    this.sub = this.cs.generalEventSubscribe('shape-add-mode-changed', () => {
      this.cdr.detectChanges();
    });
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  isActive(type: typeof this.cs.shapeAddMode) {
    return this.cs.shapeAddMode === type || this.isHovered(type);
  }

  isHovered(type: typeof this.cs.shapeAddMode) {
    return this.hovered === type;
  }

  hover(type: typeof this.cs.shapeAddMode) {
    this.hovered = type;
  }

  unhover() {
    this.hovered = undefined;
  }

  click(type: typeof this.cs.shapeAddMode) {
    if (type === 'image-gen') {
      console.log('image-gen > overlayConfig');
      this.cs.store.dispatch(setOverlay({ value: 'image-prompt' }));
      this.cs.shapeAddMode = null;
    } else {
      this.cs.shapeAddMode = type;
    }
  }

  pendingFiles: File[] = [];
  async onFileSelected(event: Event) {
    const fileInput = event.target as HTMLInputElement;

    const file = fileInput.files?.[0];
    if (!file) {
      return;
    }

    const [x, y] = [_screenX / 2, _screenY / 3];
    for (const file of Array.from(fileInput.files)) {
      const extension = file.name.split('.').pop()?.toLowerCase();

      const { data: base64, error: toBase64Error } =
        await this.cs.toBase64(file);
      // if (toBase64Error) {
      //   throw new Error(
      //     `Base64 conversion of the uploaded file resulted an error: ${toBase64Error.message}`,
      //   );
      // }
      // const imageShape = this.cs.previewShape.addImageShape([x, y], base64);
      // const { error } = await this.cs.httpService.saveImageToS3(
      //   base64,
      //   IRIToId(imageShape.IRI),
      //   extension,
      // );

      // x += 32;
      // y += 32;
    }
  }
}
